export default __webpack_public_path__ + "static/icon-5-2-5d6ab003eae29ebee77bfe109dcf9fea.png";